import {
  GET_INSTANCES_REQUESTED,
  GET_INSTANCES_POLL,
  GET_INSTANCES_FAILURE,
  GET_INSTANCES_SUCCESS,
  GET_INSTANCE_REQUESTED,
  GET_INSTANCE_POLL,
  GET_INSTANCE_FAILURE,
  GET_INSTANCE_SUCCESS,
  GET_INSTANCE_WITH_PASSWORD_SUCCESS,
  GET_INSTANCE_WITH_PASSWORD_FAILURE,
  ADD_INSTANCE_ACL_REQUESTED,
  ADD_INSTANCE_ACL_FAILURE,
  ADD_INSTANCE_ACL_SUCCESS,
  DELETE_INSTANCE_ACL_REQUESTED,
  DELETE_INSTANCE_ACL_FAILURE,
  DELETE_INSTANCE_ACL_SUCCESS,
  DELETE_INSTANCE_REQUESTED,
  DELETE_INSTANCE_FAILURE,
  DELETE_INSTANCE_SUCCESS,
  GET_INSTANCE_USERS_REQUESTED,
  GET_INSTANCE_USERS_SUCCESS,
  GET_INSTANCE_USERS_FAILURE,
  DELETE_INSTANCE_USER_REQUESTED,
  DELETE_INSTANCE_USER_FAILURE,
  DELETE_INSTANCE_USER_SUCCESS,
  RESET_INSTANCE_ERROR_STATE,
  ADD_INSTANCE_USER_REQUESTED,
  ADD_INSTANCE_USER_FAILURE,
  ADD_INSTANCE_USER_SUCCESS,
  GET_INSTANCE_DATABASES_REQUESTED,
  GET_INSTANCE_DATABASES_FAILURE,
  GET_INSTANCE_DATABASES_SUCCESS,
  ADD_INSTANCE_DATABASE_REQUESTED,
  ADD_INSTANCE_DATABASE_FAILURE,
  ADD_INSTANCE_DATABASE_SUCCESS,
  DELETE_INSTANCE_DATABASE_REQUESTED,
  DELETE_INSTANCE_DATABASE_FAILURE,
  DELETE_INSTANCE_DATABASE_SUCCESS,
  GET_SPACEUSAGE_REQUESTED,
  GET_SPACEUSAGE_SUCCESS,
  GET_SPACEUSAGE_FAILURE,
  GET_INSTANCE_CERTIFICATES_REQUESTED,
  GET_INSTANCE_CERTIFICATES_FAILURE,
  GET_INSTANCE_CERTIFICATES_SUCCESS,
  GET_INSTANCE_CLIENT_CERTIFICATES_REQUESTED,
  GET_INSTANCE_CLIENT_CERTIFICATES_FAILURE,
  GET_INSTANCE_CLIENT_CERTIFICATES_SUCCESS,
  GET_INSTANCE_CERTIFICATE_DOWNLOAD_REQUESTED,
  GET_INSTANCE_CERTIFICATE_DOWNLOAD_FAILURE,
  GET_INSTANCE_CERTIFICATE_DOWNLOAD_SUCCESS,
  CREATE_INSTANCE_CERTIFICATE_REQUESTED,
  CREATE_INSTANCE_CERTIFICATE_FAILURE,
  CREATE_INSTANCE_CERTIFICATE_SUCCESS,
  CREATE_INSTANCE_CLIENT_CERTIFICATE_REQUESTED,
  CREATE_INSTANCE_CLIENT_CERTIFICATE_FAILURE,
  CREATE_INSTANCE_CLIENT_CERTIFICATE_SUCCESS,
  DELETE_INSTANCE_CERTIFICATE_REQUESTED,
  DELETE_INSTANCE_CERTIFICATE_FAILURE,
  DELETE_INSTANCE_CERTIFICATE_SUCCESS,
  GET_BACKUPS_REQUESTED,
  GET_BACKUPS_FAILURE,
  GET_BACKUPS_SUCCESS,
  GET_PITR_BACKUP_REQUESTED,
  GET_PITR_BACKUP_FAILURE,
  GET_PITR_BACKUP_SUCCESS,
  PATCH_CONFIG_REQUESTED,
  PATCH_CONFIG_FAILURE,
  PATCH_CONFIG_SUCCESS,
  CHANGE_NODE_QUANTITY_REQUESTED,
  CHANGE_NODE_QUANTITY_FAILURE,
  CHANGE_NODE_QUANTITY_SUCCESS,
} from '../actions';

export const initialState = {
  instances: {},
  isLoading: false,
  instanceDatabaseIsLoading: false,
  error: null,
};

export default (state = initialState, action) => {
  let updatedInstance = null;
  switch (action.type) {
    case GET_INSTANCE_REQUESTED:
    case GET_INSTANCES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_INSTANCE_POLL:
    case GET_INSTANCES_POLL:
      return {
        ...state,
      };

    case GET_INSTANCES_SUCCESS:
      return {
        ...state,
        instances: Object.assign(
          {},
          ...action.payload.map((instance) => {
            let newInstance = { ...instance };
            if (state.instances[instance.id]) {
              newInstance = { ...state.instances[instance.id], ...newInstance };
            }
            return { [instance.id]: newInstance };
          }),
        ),
        isLoading: false,
      };

    case GET_INSTANCES_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case GET_INSTANCE_SUCCESS:
    case GET_INSTANCE_WITH_PASSWORD_SUCCESS:
      // Preserve space stats information
      updatedInstance = { ...state.instances[action.payload.id], ...action.payload };
      return {
        ...state,
        instances: { ...state.instances, [action.payload.id]: updatedInstance },
        isLoading: false,
      };

    case GET_INSTANCE_FAILURE:
    case GET_INSTANCE_WITH_PASSWORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ADD_INSTANCE_ACL_REQUESTED:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case ADD_INSTANCE_ACL_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.id]: {
            ...state.instances[action.meta.id],
            acls: [
              ...state.instances[action.meta.id].acls,
              { ...action.meta.data, id: action.payload.id },
            ],
          },
        },
        isLoading: false,
      };

    case ADD_INSTANCE_ACL_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case DELETE_INSTANCE_ACL_REQUESTED:
      return {
        ...state,
        error: null,
      };

    case DELETE_INSTANCE_ACL_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            acls: state.instances[action.meta.instanceId].acls.filter(
              (acl) => acl.id !== action.meta.aclId,
            ), // eslint-disable-line max-len
          },
        },
        isLoading: false,
      };

    case DELETE_INSTANCE_ACL_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case DELETE_INSTANCE_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case DELETE_INSTANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case DELETE_INSTANCE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case GET_INSTANCE_USERS_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_INSTANCE_USERS_SUCCESS:
      // This if statement exists because the Postgres API returns
      // a different payload than ES and CRDB.
      // It needs to be removed when the APIS are consistent
      // eslint-disable-next-line no-case-declarations
      let payload;
      if (Array.isArray(action.payload)) {
        payload = [...action.payload];
      } else {
        payload = [...action.payload.users];
      }
      return {
        ...state,
        isLoading: false,
        instances: {
          ...state.instances,
          [action.meta.id]: {
            ...state.instances[action.meta.id],
            users: payload,
          },
        },
      };

    case GET_INSTANCE_USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case DELETE_INSTANCE_USER_REQUESTED:
      return {
        ...state,
        error: null,
      };

    case DELETE_INSTANCE_USER_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            users: state.instances[action.meta.instanceId].users.filter(
              (user) => user.username !== action.meta.userName,
            ),
          },
        },
        isLoading: false,
      };

    case DELETE_INSTANCE_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case RESET_INSTANCE_ERROR_STATE:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_INSTANCE_USER_REQUESTED:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case ADD_INSTANCE_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ADD_INSTANCE_USER_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            users: [
              ...(state.instances[action.meta.instanceId].users || []),
              { ...action.meta.data },
            ],
          },
        },
        isLoading: false,
      };

    case GET_INSTANCE_DATABASES_REQUESTED:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case GET_INSTANCE_DATABASES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case GET_INSTANCE_DATABASES_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            databases: action.payload,
          },
        },
        isLoading: false,
      };

    case ADD_INSTANCE_DATABASE_REQUESTED:
      return {
        ...state,
        instanceDatabaseIsLoading: true,
        error: null,
      };

    case ADD_INSTANCE_DATABASE_SUCCESS:
      return {
        ...state,
        instanceDatabaseIsLoading: false,
      };

    case ADD_INSTANCE_DATABASE_FAILURE:
      return {
        ...state,
        instanceDatabaseIsLoading: false,
        error: action.payload,
      };

    case DELETE_INSTANCE_DATABASE_REQUESTED:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case DELETE_INSTANCE_DATABASE_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            databases: state.instances[action.meta.instanceId].databases.filter((database) => {
              // For keys CRDB uses name, Mongo uses db
              const dbName = database.db || database.name;
              return dbName !== action.meta.name;
            }),
          },
        },
        isLoading: false,
      };

    case DELETE_INSTANCE_DATABASE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case GET_SPACEUSAGE_REQUESTED:
      return {
        ...state,
      };

    case GET_SPACEUSAGE_FAILURE:
      return {
        ...state,
      };

    case GET_SPACEUSAGE_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            spaceUsage: { ...action.payload },
          },
        },
      };

    case GET_INSTANCE_CERTIFICATES_REQUESTED:
      return {
        ...state,
      };

    case GET_INSTANCE_CERTIFICATES_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case GET_INSTANCE_CERTIFICATES_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            certificates: action.payload,
            CACertId: action.payload[0] ? action.payload[0].id : '',
          },
        },
      };

    case GET_INSTANCE_CLIENT_CERTIFICATES_REQUESTED:
      return {
        ...state,
      };

    case GET_INSTANCE_CLIENT_CERTIFICATES_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case GET_INSTANCE_CLIENT_CERTIFICATES_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            clientCerts: action.payload,
          },
        },
      };

    case GET_INSTANCE_CERTIFICATE_DOWNLOAD_REQUESTED:
      return {
        ...state,
      };

    case GET_INSTANCE_CERTIFICATE_DOWNLOAD_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case GET_INSTANCE_CERTIFICATE_DOWNLOAD_SUCCESS:
      return {
        ...state,
      };

    case CREATE_INSTANCE_CERTIFICATE_REQUESTED:
      return {
        ...state,
      };

    case CREATE_INSTANCE_CERTIFICATE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case CREATE_INSTANCE_CERTIFICATE_SUCCESS:
      return {
        ...state,
      };

    case CREATE_INSTANCE_CLIENT_CERTIFICATE_REQUESTED:
      return {
        ...state,
      };

    case CREATE_INSTANCE_CLIENT_CERTIFICATE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case CREATE_INSTANCE_CLIENT_CERTIFICATE_SUCCESS:
      return {
        ...state,
      };

    case DELETE_INSTANCE_CERTIFICATE_REQUESTED:
      return {
        ...state,
      };

    case DELETE_INSTANCE_CERTIFICATE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_INSTANCE_CERTIFICATE_SUCCESS:
      return {
        ...state,
      };

    case GET_BACKUPS_REQUESTED:
      return {
        ...state,
      };

    case GET_BACKUPS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case GET_BACKUPS_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            backups: action.payload,
          },
        },
      };
    
    case GET_PITR_BACKUP_REQUESTED:
      return {
        ...state,
      };

    case GET_PITR_BACKUP_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PITR_BACKUP_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            pitrBackupInfo: action.payload,
          },
        },
      };

    case PATCH_CONFIG_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case PATCH_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case PATCH_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        instances: { ...state.instances, [action.payload.id]: action.payload },
      };

    case CHANGE_NODE_QUANTITY_REQUESTED:
    case CHANGE_NODE_QUANTITY_SUCCESS:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
            statusDisplay: 'Update Requested',
          },
        },
      };

    case CHANGE_NODE_QUANTITY_FAILURE:
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.meta.instanceId]: {
            ...state.instances[action.meta.instanceId],
          },
        },
        error: action.payload,
      };

    default:
      return state;
  }
};
